import { EnumUiBackgroundEffect } from '@domains/frontend/ui-components';

import { EnumEventBanner } from './event-banner/event-banner.data';
import { EnumEventTheme } from '../../../shared/constants/event-theme.constant';


/**------------------------------------------------------
 * Event Theme Definitions
 */
export const EVENT_THEMES_CONFIG: IEventThemeConfig[] = [
	// {
	// 	code : EnumEventTheme.Christmas,
	// 	view : {
	// 		background	: EnumUiBackgroundEffect.Snowflakes,
	// 		banner		: EnumEventBanner.Christmas,
	// 	},
	// 	condition : {
	// 		manual 		: false,
	// 		schedule 	: {
	// 			start : new Date('2020-12-21'),
	// 			end   : new Date('2020-12-30'),
	// 		}
	// 	}
	// },
	// {
	// 	code : EnumEventTheme.NewYear,
	// 	view : {
	// 		background	: EnumUiBackgroundEffect.Snowflakes,
	// 		banner		: EnumEventBanner.NewYear,
	// 	},
	// 	condition : {
	// 		manual 		: false,
	// 		schedule 	: {
	// 			start : new Date('2020-12-31'),
	// 			end   : new Date('2020-01-01'),
	// 		}
	// 	}
	// },
	// ...
];


/**------------------------------------------------------
 * Interface Definitions
 */
export interface IEventThemeConfig {
	code 		: EnumEventTheme;
	view 		: IEventThemeView;
	condition 	: {
		manual 		: boolean;
		schedule   ?: IScheduleDate;
	};
}

export interface IScheduleDate {
	start	: Date;
	end		: Date;
}

export interface IEventThemeView {
	background	 : EnumUiBackgroundEffect;
	banner		?: EnumEventBanner;
}
